import { FormationProps } from '@/types/formation';

export const extincteurFormation: (FormationProps & {
  objectives: string[];
  targetAudience: string;
  prerequisites: string;
  program: { title: string; items: string[] }[];
  price?: string;
  reference?: string;
  certification?: string;
  accessibilityCriteria?: string;
  registrationProcess?: string[];
  evaluationMethods?: string[];
  pedagogicalMethods?: string[];
  formatterInfo?: {
    name: string;
    phone: string;
    email: string;
    website: string;
  };
}) = {
  id: '4',
  title: 'Formation Manipulation Extincteurs',
  reference: 'F-EPI',
  description: "Apprenez à identifier les indices annonciateurs de naissance et de propagation d'un incendie, utiliser efficacement un extincteur et adopter les comportements adéquats face aux différents moyens de première intervention.",
  duration: '4 heures (1/2 journée)',
  category: 'Incendie',
  price: 'Sur devis – nous contacter',
  imageSrc: '/images/formations/extincteurfiche.webp',
  slug: 'manipulation-extincteurs',
  objectives: [
    "Maîtriser les connaissances des causes de naissance et de propagation d'un incendie",
    "Savoir utiliser efficacement les différents types d'extincteurs et adapter les techniques d'intervention aux moyens de première intervention",
    "Adopter un quotidien un comportement préventif face au risque incendie en mettant en application les bonnes pratiques de prévention du risque incendie"
  ],
  targetAudience: "Personnel travaillant dans l'entreprise",
  prerequisites: "Être âgé de 18 ans\nÊtre apte médicalement",
  certification: "Remise d'une attestation de compétences nominative après la réalisation du QCM final et évaluation des acquis",
  accessibilityCriteria: "Pour toute personne en situation d'handicap, nous sommes susceptibles de pouvoir vous accueillir. Merci de nous contacter au préalable pour étudier toute situation.",
  registrationProcess: [
    "Inscription par téléphone, par mail ou via le site internet",
    "Délai d'accès selon un agenda interne de l'entreprise",
    "Minimum 10 jours avant le début de la formation"
  ],
  evaluationMethods: [
    "1er jour de la formation : Questionnaire des besoins et positionnement de l'apprenant",
    "Pendant la formation : Atelier pratique en situation réelle + exercice applicable",
    "Fin de formation : QCM pour évaluation des acquis + évaluation de satisfaction à chaud",
    "Après la formation : Évaluation à froid pour vérifier les compétences de l'apprenant"
  ],
  pedagogicalMethods: [
    "Exposés interactifs, démonstrations par le formateur, exercice sur feux réels"
  ],
  formatterInfo: {
    name: "Sébastien DAVRAINVILLE",
    phone: "06 22 01 04 09",
    email: "sdpsiformation@orange.fr",
    website: "www.sdpsiformation.fr"
  },
  program: [
    {
      title: "Les éléments du triangle du feu",
      items: [
        "Les causes d'un incendie",
        "Les modes de propagation",
        "Les classes de feu"
      ]
    },
    {
      title: "Les moyens d'extinction",
      items: [
        "Les différents types d'extincteurs et les agents extincteurs",
        "Principe de fonctionnement, méthodologie d'utilisation d'un extincteur et d'un RIA (robinet d'incendie armé)"
      ]
    },
    {
      title: "Les facteurs aggravants",
      items: [
        "Le comportement du matériel",
        "Les formes de combustion"
      ]
    },
    {
      title: "Conduite à tenir en cas d'alarme et d'évacuation",
      items: [
        "Enfermez le feu",
        "Évacuez sans prise de risque vers le point de rassemblement",
        "Respectez l'aide à l'évacuation",
        "La prévention des incendies",
        "Exercice d'évacuation"
      ]
    },
    {
      title: "Conduite à tenir particulière",
      items: [
        "La propagation d'un incendie (fumée en circulation)",
        "Le flash over, le back draft et les règles de sécurité"
      ]
    },
    {
      title: "Partie pratique EPI",
      items: [
        "Fonctionnement d'un extincteur",
        "Mettre en œuvre un extincteur Eau Pulvérisée (3 litres à pression auxiliaire)",
        "Mettre en œuvre un extincteur CO2 (2 poudres permettant)",
        "Mettre en œuvre un extincteur Eau Pulvérisée (6 litres à pression permanente)",
        "Reconnaissance et identification des itinéraires d'évacuation"
      ]
    }
  ]
};
